import React, { useState } from "react";
import {
  makeStyles,
  Typography,
  Divider,
  IconButton,
  useTheme,
  CircularProgress,
} from "@material-ui/core";
import moment from "moment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import { DateInput } from "../../components/Form";
import { useAlert } from "../../components/Alert";
import { propertyDataArray } from "../../components/PropertyDataArray";

const GET_PROPERTYTABLE = gql`
  query propertyTable($date: Date!) {
    propertyTable(date: $date) {
      count
    }
  }
`;

export default function ObjCheckTable() {
  const theme = useTheme();
  const Alert = useAlert();
  const useStyles = makeStyles({
    DocumentContainerColumn: {
      flexDirection: "column",
    },
    DocumentContainerRow: {
      flexDirection: "row",
    },
    DocumentContainerCenter: {
      display: "flex",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  const { courtArray } = propertyDataArray();

  const [newData, setNewData] = useState({
    count: [],
    date: new Date(),
    sum: [],
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const { loading } = useQuery(GET_PROPERTYTABLE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      date: newData.date,
    },
    onCompleted({ propertyTable }) {
      if (propertyTable) {
        // item1~6就是對應下面的土地、房屋...
        let newCount = [];
        let newSum = [];
        let item1 = 0;
        let item2 = 0;
        let item3 = 0;
        let item4 = 0;
        let item5 = 0;
        let item6 = 0;
        const propertyTableCount = propertyTable.count;
        courtArray.forEach(() => {
          newCount.push(propertyTableCount.slice(0, 6));
          propertyTableCount.splice(0, 6);
        });
        newCount.forEach((item, index) => {
          item1 += item[0];
          item2 += item[1];
          item3 += item[2];
          item4 += item[3];
          item5 += item[4];
          item6 += item[5];
          if (index === 21) {
            newSum.push(item1, item2, item3, item4, item5, item6);
            changeData("sum", newSum);
          }
        });
        changeData("count", newCount, true);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <>
        <CardContent
          style={{
            position: "sticky",
            top: 0,
            zIndex: 999,
            backgroundColor: "white",
            borderRadius: "5px",
          }}
        >
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <IconButton
                style={{
                  backgroundColor: theme.palette.grey[500],
                  color: "#fff",
                }}
                onClick={() => {
                  changeData(
                    "date",
                    moment(newData.date).subtract(1, "days"),
                    true
                  );
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            </Grid>
            <Grid item xs={6} sm={2}>
              <DateInput
                value={newData.date}
                format="yyyy年MM月dd日"
                onChange={(v) => changeData("date", v, true)}
              />
            </Grid>
            <Grid item>
              <IconButton
                style={{
                  backgroundColor: theme.palette.grey[500],
                  color: "#fff",
                }}
                onClick={() => {
                  changeData("date", moment(newData.date).add(1, "days"), true);
                }}
                disabled={moment(newData.date).isSame(moment(), "day")}
              >
                <ArrowForwardIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography>
                {"土地總數：" +
                  newData.sum[0] +
                  "件\u2002\u2002房屋總數：" +
                  newData.sum[1] +
                  "件\u2002\u2002應買總數：" +
                  newData.sum[2] +
                  "件\u2002\u2002司法院總數：" +
                  newData.sum[3] +
                  "件\u2002\u2002金拍屋：" +
                  newData.sum[4] +
                  "件\u2002\u2002國有財產：" +
                  newData.sum[5] +
                  "件"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Grid container spacing={1} direction="row">
          {newData.count.map((item, index) => {
            if (item.filter((item2) => item2 !== 0).length > 0) {
              return (
                <Grid item xs={4}>
                  <CardContent style={{ minHeight: 170 }}>
                    <Grid container direction="column">
                      <Grid
                        item
                        classes={{ root: classes.DocumentContainerCenter }}
                      >
                        <Typography>{courtArray[index].label}</Typography>
                      </Grid>
                    </Grid>
                    <Grid container item>
                      <Grid
                        container
                        spacing={1}
                        classes={{ root: classes.DocumentContainerColumn }}
                      >
                        <Grid container item justify={"center"}>
                          <CheckCircleIcon style={{ color: "#4caf50" }} />
                        </Grid>
                        <Grid item>
                          <Grid
                            container
                            item
                            spacing={1}
                            classes={{
                              root: classes.DocumentContainerColumn,
                            }}
                          >
                            <Grid
                              container
                              item
                              spacing={1}
                              classes={{ root: classes.DocumentContainerRow }}
                            >
                              <Grid item sm={4}>
                                <Typography>土地：{item[0]}件</Typography>
                              </Grid>
                              <Grid item sm={4}>
                                <Typography>房屋：{item[1]}件</Typography>
                              </Grid>
                              <Grid item sm={4}>
                                <Typography>應買：{item[2]}件</Typography>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              item
                              spacing={1}
                              classes={{ root: classes.DocumentContainerRow }}
                            >
                              <Grid item sm={4}>
                                <Typography>
                                  司法院：
                                  {item[3]}件
                                </Typography>
                              </Grid>
                              <Grid item sm={4}>
                                <Typography>
                                  金拍屋：
                                  {item[4]}件
                                </Typography>
                              </Grid>
                              <Grid item sm={4}>
                                <Typography>
                                  國有財產：
                                  {item[5]}件
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4}>
                  <CardContent style={{ minHeight: 170 }}>
                    <Grid container direction="column">
                      <Grid
                        item
                        classes={{ root: classes.DocumentContainerCenter }}
                      >
                        <Typography>{courtArray[index].label}</Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      item
                      justify="center"
                      alignItems="center"
                      style={{ paddingTop: 50 }}
                    >
                      <CancelIcon style={{ color: "#f44336" }} />
                    </Grid>
                  </CardContent>
                  <Divider />
                </Grid>
              );
            }
          })}
        </Grid>
      </>
    );
  }
}
